import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { config } from '../../../../config';
import { Fee } from './fee.model';

interface FeesResponse {
  data: Fee[];
}

@Injectable()
export class FeeService {
  constructor(private http: HttpClient) {}

  get(): Observable<Fee[]> {
    return this.http
      .get<FeesResponse>(`${config.apiLocation}/v1/fees?format=basic`)
      .map(res => res.data);
  }

  declined(client_id: string, payment_reference: string, amount: number) {
    return this.http
      .post<{ data: any }>(`${config.apiLocation}/v1/fees/declined`, { client_id, payment_reference, amount })
      .map(res => res.data);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/fees/fee.service.ts